module.exports = __webpack_public_path__ + "static/media/image-1.f8462c72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/image-1.jpg
// module id = 495
// module chunks = 0